import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';
import { IBannerTabStep } from '../../../models/common';
import { forLifeOf, LifecycleAware } from '../../../utilities/rxjs.helpers';

@LifecycleAware()
@Component({
    selector: 'lsq-banner-step-tabs',
    template: `
        <ul class="{{ id }}-step-tabs step-tabs list-group flex-row" [ngClass]="className">
            <ng-container *ngFor="let step of steps; let i = index">
                <ng-template #stepTabChildren>
                    <span class="{{ id }}-step-number step-number">{{ i + 1 }}</span>
                    <span class="{{ id }}-step-title step-title">{{ step.title }}</span>
                </ng-template>

                <li
                    class="{{ id }}-step-tab step-tab-{{ i }} step-tab list-group-item {{
                        step.className || ''
                    }}"
                    [ngClass]="{
                        active: activeStepIndex === i,
                        complete: activeStepIndex > i || allStepsComplete
                    }"
                >
                    <ng-container *ngTemplateOutlet="stepTabChildren"></ng-container>
                </li>
            </ng-container>
        </ul>
    `,
    styleUrls: ['./lsq-banner-step-tabs.component.scss']
})
export class LsqBannerStepTabsComponent implements OnInit, OnDestroy {
    @Input() public id = 'lsq';
    @Input() public className = '';
    @Input() public allStepsComplete = false;
    @Input() public steps: IBannerTabStep[] = [];
    @Output() public activeStepChange = new EventEmitter<{ title: string; className?: string }>();
    @Output() public activeStepIndexChange = new EventEmitter<number>();
    private _activeStep: IBannerTabStep;
    private _activeStepIndex: number;

    constructor(private _router: Router) {}

    public ngOnInit(): void {
        if (this.steps.some((step) => !!step.routerLinkUrl)) {
            this._router.events
                .pipe(
                    forLifeOf(this),
                    filter((event) => event instanceof NavigationEnd),
                    startWith({})
                )
                .subscribe(() => {
                    this._activeStepIndex = this.steps.findIndex(
                        (step) => this._router.url.indexOf(step.routerLinkUrl) > -1
                    );
                });
        }
    }

    public ngOnDestroy(): void {}

    @Input()
    public get activeStep(): { title: string; className?: string } {
        return this._activeStep;
    }
    public set activeStep(val: { title: string; className?: string }) {
        this._activeStep = val;
        this._activeStepIndex = this.steps.indexOf(this._activeStep);
        this._emitActiveStepAndIndexChanges();
    }

    @Input()
    public get activeStepIndex(): number {
        return this._activeStepIndex;
    }
    public set activeStepIndex(val: number) {
        this._activeStepIndex = val;
        this._activeStep = this.steps[this._activeStepIndex];
        this._emitActiveStepAndIndexChanges();
    }

    // Private methods.
    private _emitActiveStepAndIndexChanges(): void {
        this.activeStepChange.emit(this._activeStep);
        this.activeStepIndexChange.emit(this._activeStepIndex);
    }
}
